import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

import ContentCarousel from 'rebook/apps/base/components/ContentCarousel';
import { HEADER_LINKS } from 'rebook/mybook/App/Header/constants';

import styles from './style.scss';


const LinkList = () => {
  return (
    <div className={classNames(styles.linksContainer, 'swiper-slide')}>
      {HEADER_LINKS.map((item, i) => (
        <div className={classNames(styles.linkContainer)} key={`${i}_${item.link}`}>
          <Link to={item.link} className={classNames(styles.link, 'link')}>
            {item.text}
          </Link>
        </div>
      ))}
    </div>
  );
};

const HeaderLinks = ({ isMobile }) => {
  return (
    <div className={classNames(
      styles.headerLinks,
      isMobile ? 'jest-mobile-header-links-to-catalog' : 'jest-header-links-to-catalog')}>
      <ContentCarousel extraClassName={styles.carousel} slidesOffsetBefore="16" slidesOffsetAfter="16">
        <LinkList />
      </ContentCarousel>
      <div className={styles.list}>
        <LinkList />
      </div>
    </div>
  );
};

export default HeaderLinks;
